export default "__VITE_ASSET__CM_qaX3Q__"